<!-- 注意事項 :/notice -->
<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <h2 class="page_main_title">
        其他注意事項
      </h2>

      <div
        class="terms_content"
        v-html="term"
      />
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { AppDialog } from '@/components/Modal/';
import { getPolicyDetail } from '@/libs/API/apis';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'Notice',
  components: {
    AppDialog
  },
  setup () {
    const { dialogName } = useCommon();

    const term = ref('');

    const getPolicyData = () => {
      getPolicyDetail('other_notices')
        .then((res) => {
          term.value = res;
        });
    };

    onMounted(() => {
      getPolicyData();
    });

    return {
      dialogName,
      term
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .container_wrapper {
    .terms_content {
      @include font-size-16;

      color: $mono_80;
      letter-spacing: 1px;
      word-wrap: break-word;
      white-space: pre-wrap;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
